export default function About() {
  return (
    <section id="about" className="relative py-32 px-12 bg-stone-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <span className="text-sm text-stone-600 font-light tracking-wider">/about-us</span>
        </div>
        
        <div className="grid grid-cols-12 gap-16">
          {/* Left side - breathing space */}
          <div className="col-span-4 flex flex-col justify-between">
            <div className="text-xs text-stone-400 font-light">
              <span className="inline-block w-2 h-2 rounded-full bg-stone-400 mr-2"></span>
              Est. 2020
            </div>
            
            <div className="mt-auto">
              <div className="flex items-center gap-2 mb-4">
                <div className="flex -space-x-2">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-stone-300 to-stone-400 border-2 border-stone-50"></div>
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-stone-400 to-stone-500 border-2 border-stone-50"></div>
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-stone-500 to-stone-600 border-2 border-stone-50"></div>
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-stone-600 to-stone-700 border-2 border-stone-50"></div>
                </div>
              </div>
              <p className="text-base text-stone-800 font-light">Expert iOS Development Team</p>
            </div>
          </div>

          {/* Right side - main content */}
          <div className="col-span-8">
            <p className="text-4xl font-light text-stone-900 leading-relaxed">
              Axi AS is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices. We combine innovative technology with elegant design to deliver solutions that users trust and love.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}